// extracted by mini-css-extract-plugin
export var tagItem = "TagItem-module--tagItem--e1acb";
export var tagItem___selected = "TagItem-module--tagItem___selected--6cbba";